window.addEventListener('load', function() {
    var viewport = document.querySelector('.product__media-list .flickity-viewport');
    
    if (viewport) {
        console.log('Flickity viewport found and script is running');

        // Force Flickity to recalculate dimensions
        var resizeEvent = new Event('resize');
        window.dispatchEvent(resizeEvent);

        // Additional check to trigger resize after a slight delay
        setTimeout(function() {
            window.dispatchEvent(resizeEvent);
            console.log('Resize event triggered after delay');
        }, 100);
    } else {
        console.log('Flickity viewport not found');
    }
});


window.addEventListener('load', function() {
    var sublistViewport = document.querySelector('.product__outer ul.product__media-sublist .flickity-viewport');

    if (sublistViewport) {
        console.log('Sublist Flickity viewport found and script is running');

        function updateHeight() {
            var screenWidth = window.innerWidth;
            var minHeight;

            // Set the min-height based on screen size
            if (screenWidth < 550) {
                minHeight = '90px'; // Mobile min-height
            } else if (screenWidth >= 550 && screenWidth < 750) {
                minHeight = '185px'; // Between 550px and 750px min-height
            } else if (screenWidth >= 750 && screenWidth < 1500) {
                minHeight = '180px'; // Tablet min-height
            } else {
                minHeight = '280px'; // Desktop min-height
            }

            // Apply both min-height and height
            sublistViewport.style.minHeight = minHeight;
            sublistViewport.style.height = minHeight;

            console.log('Sublist viewport min-height and height set to: ' + minHeight);
        }

        // Wait for images to load before applying the height
        var images = sublistViewport.querySelectorAll('img');
        var imagesLoaded = 0;

        images.forEach(function(img) {
            img.addEventListener('load', function() {
                imagesLoaded++;
                if (imagesLoaded === images.length) {
                    setTimeout(updateHeight, 300); // Set min-height and height after all images load
                }
            });

            // In case the image is already loaded
            if (img.complete) {
                imagesLoaded++;
            }

            if (imagesLoaded === images.length) {
                setTimeout(updateHeight, 300); // Set min-height and height if all images are already loaded
            }
        });

        // Update height on window resize
        window.addEventListener('resize', function() {
            setTimeout(updateHeight, 100);
        });

        // Monitor for any changes in the viewport and adjust height accordingly
        var observer = new MutationObserver(updateHeight);
        observer.observe(sublistViewport, { childList: true, subtree: true });
    } else {
        console.log('Sublist Flickity viewport not found');
    }
});

